import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import TextArea from "../../form/TextArea";
import CheckBox from "../../form/CheckBox";
import Figures from "../../form/Figures";
import UrlField from "../../form/UrlField";
import TypeTextEditor from "../../form/TypeTextEditor";
import {isTrue} from "../../../utils/other";
import ComponentConfig from "../../form/ComponentConfig";
import moment from "moment";

class PromotionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput
                            name="name"
                            value={this.props.values.name}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("name")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextInput
                                name="subtitle"
                                value={this.props.values.subtitle}
                                label="Alcím"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("subtitle")}
                            />
                        </div>
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("start_date")}
                                isClearable={true}
                                maxDate={this.props.values.end_date}
                                name="start_date"
                                value={this.props.values.start_date}
                                label="Kezdés"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("end_date")}
                                isClearable={true}
                                minDate={this.props.values.start_date}
                                name="end_date"
                                value={this.props.values.end_date}
                                label="Vég"
                                showTime={true}
                                initialValue={moment().format("YYYY-MM-DD") + " 00:00"}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor
                            name="shortdescription"
                            label="Rövid leírás"
                            data={this.props.values}
                            componentConfig={this.props.promotionConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor
                            name="description"
                            label="Leírás"
                            data={this.props.values}
                            componentConfig={this.props.promotionConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures
                            name="images"
                            label="Képek"
                            componentConfig={this.props.promotionConfig}
                            data={this.props.values}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <CheckBox
                                {...this.props.getFieldProps("visible_index")}
                                name="visible_index"
                                value={this.props.values.visible_index}
                                checked={isTrue(this.props.values.visible_index)}
                                label="Megjelenik a főoldalon"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(PromotionForm);
